import * as QueryString from "querystringify";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import { FDStatement, FDUpdateForm } from "./components";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { AuthHelper } from "../../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    user: AuthHelper.getBasicUserProfile(AuthHelper.tokenData(state.auth)),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
});

type OwnProps = RouteComponentProps<{}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
    user: M.User.BasicProfile;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
};

interface OwnState {
    fd?: M.FinancialDisclosure.FD;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class FinancialDisclosureUpdateComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private _form: FDUpdateForm | null = null;

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    public componentDidMount() {
        this.loadData();
        this._isMounted = true;
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        return <Comp.Page.PublicPage additionalClasses="full" pageTitle={"Update Financial Disclosure"}>
                {this.getErrorAlert()}

                <h1>Financial Disclosure Statement</h1>

                <FDStatement />

                <hr />

                <div style={{ position: "relative" }}>
                    <Comp.Generic.LoadingSpinner show={this.state.loading} />
                    <FDUpdateForm
                        api={this.props.api}
                        fd={this.state.fd}
                        loading={this.state.loading}
                        user={this.props.user}
                        onSubmit={(model, body) => this.onSubmit(model, body)}
                        ref={(ref: any) => this._form = ref}
                    />
                </div>
            </Comp.Page.PublicPage>;
    }

    private getReturnUrl() {
        const queryString = QueryString.parse(this.props.location.search);
        let returnUrl = Paths.User.Account;

        if (queryString["returnUrl"])
            returnUrl = decodeURIComponent(queryString["returnUrl"]);

        return returnUrl;
    }

    private async loadData() {
        const result = await this.props.api.get(Api.endpoints.users.financialDisclosure.get);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            this.setState({ ...this.state, fd: result.data, loading: false }, () => {
                if (this._form && result.data)
                    this._form.setFormData(result.data);
            });
        }
        else if (result.isSuccess) {
            this.setState({ ...this.state, loading: false });
        }
        else {
            this.setErrors(M.Result.Result.errorsOrMessage(result));
        }
    }

    private async onSubmit(model: Forms.FinancialDisclosure.FinancialDisclosureData, body: any) {
        if (!this._form)
            return;

        this._form.toggleProcessing(true);

        const result = await this.props.api.post(Api.endpoints.users.financialDisclosure.get, {
            body: JSON.stringify(body),
        });

        if (!this._isMounted || !this._form)
            return;

        this._form.toggleProcessing(false);

        if (result.isSuccess && result.data) {
            this.props.goto(this.getReturnUrl());
            this.props.notifySuccess("Financial disclosure has been successfully updated.");
        }
        else {
            this._form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
        }
    }
}

export const FinancialDisclosureUpdate: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(FinancialDisclosureUpdateComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/user/financialDisclosure/FinancialDisclosureUpdate.tsx